<template>
    <v-dialog v-model="createDlg" width="800px" persistent>
        <v-form data-vv-scope="createForm">
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formName)
                            }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                            @click="onCancel"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                            <v-select :label="$t('lang.role.roleName')"
                                      v-model.trim="createItem.roleId"
                                      v-validate="'required'"
                                      name="role"
                                      :items="lstRole"
                                      item-text="roleName"
                                      item-value="id"
                                      @change="getUserList"
                                      :data-vv-as="$t('lang.role.roleName')"
                                      :error-messages="errors.first('role')"/>

                        </v-flex>
                        <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                            <v-select :label="$t('lang.user.fullName')"
                                      v-model.trim="createItem.userId"
                                      v-validate="'required'"
                                      name="createPondId"
                                      :items="lstUser"
                                      item-text="fullName"
                                      item-value="userId"
                                      :data-vv-as="$t('lang.user.fullName')"
                                      clearable
                                      :error-messages="errors.first('createPondId')"/>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="primary" @click="onSave" :key="saveSession">
                        {{ $t("lang.report.send") }}
                    </v-btn>
                    <v-btn color="error" @click="onCancel">
                        {{ $t("lang.common.cancel") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import axios from "axios";

    export default {
        name: "send-report",
        components: {},
        data: () => {
            return {
                formName: "Gửi báo cáo",
                createDlg: false,
                createItem:{},
                lstRole: [],
                lstUser: [],
                saveSession: new Date().getTime(),
            };
        },

        created() {
            this.getRoleList();
        },

        methods: {
            getRoleList() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/role/search",{active:1}
                ).then(
                    (data) => {
                        if (data.count > 0) {
                            this.lstRole = data.items;
                        }
                    }
                );
            },

            getUserList() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/user/search", {roleId: this.createItem.roleId}
                ).then(
                    (data) => {
                        if (data.count > 0) {
                            this.lstUser = data.items;
                        }
                    }
                );
            },

            onShow(){
                this.createDlg = true;
            },

            onCancel() {
                this.createDlg = false;
            },

            onSave() {
                this.$validator.validateAll("createForm").then(valid => {
                    if (valid) {
                        this.$emit("send",this.createItem);
                    } else {
                        message.error("Thông tin nhập chưa chính xác")
                        this.saveSession = new Date().getTime();
                    }
                })

            },

        },

        destroyed() {
        },
    };
</script>

<style>
    .indicator {
        margin: 5px 5px 5px 0px;
        padding: 5px;
        display: inline-block;
        border: 1px solid gray;
        width: fit-content;
    }

    .G2 {
        background-color: gold;
    }

    .G3 {
        background-color: crimson;
    }
</style>